import { render, staticRenderFns } from "./RemoveResponse.vue?vue&type=template&id=106035a0&"
import script from "./RemoveResponse.vue?vue&type=script&lang=js&"
export * from "./RemoveResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports